export default {
    props: {
        defaultModObj: Object
    },
    data () {
        return {
            schemaUrlParams: {
                module: "sheet",
                name: "schema"
            },

            modObj: undefined,
            modSchemaLoading: false,
            modSchemaErrorMsg: "",

            getScreen (screenKey) {
                return this.screens.find((screenItem) => screenItem._key === screenKey);
            },
            getFormList (screenKey, groupKey, fieldTypes = []) {
                // 1.视图的form,不传视图给表的form
                let formList = screenKey
                    ? (this.getScreen(screenKey) || { form: [] }).form
                    : this.modFormList;

                // 2.处理form字段 的权限和其他值
                formList = formList.filter((formItem) => {
                    this.dealFormItem(formItem);
                    if (["cascaderTable", "flatTable"].includes(formItem._type)) {
                        formItem._subForm.forEach((subFormItem) => {
                            this.dealFormItem(subFormItem, formItem);
                        });
                    }

                    // 过滤掉隐藏字段
                    if (formItem._displayType === "hide") {
                        return false;
                    } else {
                        return true;
                    }
                });

                // 3.组的form,不传组给全部form
                formList = groupKey
                    ? formList.filter((formItem) => formItem._group === groupKey)
                    : formList;

                // 4.某些类型的form字段,不传组给全部form
                formList = fieldTypes.length
                    ? formList.filter((formItem) => fieldTypes.includes(formItem._type))
                    : formList;

                return formList;
            },
            getFormItem (fieldKey) {
                return this.modFormList.find((formItem) => formItem._key === fieldKey);
            },

            // 衍生方法 -可不存在，目的是方便
            getCurScreenGroupFormList (groupKey) {
                return this.getFormList(this.screenKey, groupKey);
            },
            getTypeFormList (fieldTypes = [], screenKey, groupKey) {
                return this.getFormList(screenKey, groupKey, fieldTypes);
            },

            // 对 计算字段、编码字段、单条关联的一对一字段、多条关联的关联字段 权限处理下
            dealFormItem (formItem, parentItem) {
                if (
                    ["serialNumber"].includes(formItem._type) ||
                    formItem._enterType === "calculate" ||
                    [this.otoField, this.relationField, ...this.disabledFields].includes(
                        formItem._key
                    )
                ) {
                    formItem._canEdit = formItem.canEdit;
                    formItem.canEdit = false;
                }

                if (["file", "editor"].includes(formItem._type)) {
                    // 公司ID_应用ID_modKey_dataId,
                    formItem.groupKey = `${this.companyId}__${this.appId}__${
                        this.modKey
                    }__${this.dataId}${parentItem ? "__" + parentItem._type : ""}__${
                        formItem._type
                    }`;
                    formItem.urlModule = {
                        module: "file",
                        name: formItem._type == "editor" ? "editorOssToken" : "ossToken",
                        params: {
                            companyId: this.companyId
                        }
                    };
                }
            }
        };
    },
    computed: {
        // 编辑模式
        editType () {
            return this.propsObj.editType || "normal";
        },
        // 一对一字段
        otoField () {
            return this.propsObj._otoField;
        },
        // 关联字段
        relationField () {
            return this.propsObj._filterField;
        },
        // 选择展示的字段列表
        refFields () {
            return this.propsObj._refFields;
        },
        disabledFields () {
            return this.propsObj.disabledFields || [];
        },

        /* 表 一级属性 */
        modKey () {
            return (
                this.propsObj._ref ||
                this.propsObj.modKey ||
                (this.modObj && this.modObj._key) || undefined
            );
        },
        // 有表的权限取modObj.name；无表的权限取propsObj中相关modName
        modName () {
            return this.modObj
                ? this.modObj.name
                : this.propsObj._modName || this.propsObj.modName || "";
        },
        modFormList () {
            return this.modObj ? this.modObj.form : [];
        },

        /* 视图 一级属性 */
        screens () {
            return this.modObj ? this.modObj.screens : [];
        },
        showScreens () {
            return this.screens.filter((screenItem) => screenItem.hasAccess);
        },
        screenKey () {
            return this.propsObj._screen || this.propsObj.screenKey || undefined;
        },
        curScreen () {
            return this.screenKey ? this.getScreen(this.screenKey) : undefined;
        },
        // 有表的权限且有当前视图权限，取curScreen.name；无表的权限或无当前视图权限，取propsObj中相关screenName
        curScreenName () {
            return this.curScreen
                ? this.curScreen.name
                : this.propsObj._screenName || this.propsObj.screenName || "";
        },
        curScreenFormList () {
            return this.screenKey ? this.getFormList(this.screenKey) : [];
        },
        curScreenFields () {
            return this.curScreenFormList.map((formItem) => formItem._key);
        },
        curScreenNoTagFormList () {
            return this.curScreenFormList.filter(
                (formItem) => formItem._type !== "tag"
            );
        },
        curScreenNoTagFields () {
            return this.curScreenNoTagFormList.map((formItem) => formItem._key);
        },
        // 展示的formList不包含tag类型
        curScreenShowFormList () {
            return this.curScreenShowFields
                .map((fieldKey) =>
                    this.curScreenNoTagFormList.find(
                        (formItem) => formItem._key === fieldKey
                    )
                )
                .filter((formItem) => !!formItem); // TODO: 剔除已删除字段、标签字段、隐藏字段等
        },
        // 展示的fields不包含tag类型
        curScreenShowFields () {
            const fields = this.refFields || this.curScreenTableFields;
            return (this.curScreen
                ? fields.length
                    ? fields
                    : this.curScreenNoTagFields
                : []
            ).slice(0, 20);
        },
        curScreenTableFields () {
            return this.curScreen
                ? this.curScreen.tableFields && this.curScreen.tableFields.length
                    ? this.curScreen.tableFields
                    : this.curScreenNoTagFields.slice(0, 20)
                : [];
        },
        curScreenDefaultSearchFields () {
            return this.curScreen ? this.curScreen.defaultSearchFields : [];
        },
        curScreenAdvSearchConditions () {
            return this.curScreen && this.curScreen.advSearch
                ? this.curScreen.advSearch.conditions
                : [];
        },

        /* 组 一级属性 */
        groups () {
            return this.modObj ? this.modObj.groups : [];
        },
        curScreenGroups () {
            return this.groups.filter((groupItem) => {
                return this.curScreenFormList.some(
                    (formItem) => formItem._group === groupItem._key
                );
            });
        },
        curScreenCurGroupFormList () {
            return this.screenKey && this.groupKey
                ? this.getCurScreenGroupFormList(this.groupKey)
                : [];
        },
        curScreenCurGroupDividerList () {
            return this.curScreenCurGroupFormList.filter(
                (formItem) => formItem._type === "tag"
            );
        },

        /* ------ 按钮相关 ----- */
        curScreenButtonRules () {
            return this.curScreen
                ? {
                    canSearch: true,
                    canShare: true,
                    canPrint: true,
                    canDrag: this.curScreen.buttonRules.canUpdate,
                    ...this.curScreen.buttonRules,
                    canBatchUpdate: this.curScreen.buttonRules.canUpdate,
                    canBatchDelete: this.curScreen.buttonRules.canDelete,
                    canBatchImport: this.curScreen.buttonRules.canImport,
                    canBatchExport: this.curScreen.buttonRules.canExport // 要么用canExport，二取一
                }
                : {};
        },
        // 所有批量按钮键名集合列表
        batchBtns () {
            return Object.entries(this.curScreenButtonRules)
                .filter((btnArrItem) => btnArrItem[0].includes("Batch"))
                .map((btnArrItem) => btnArrItem[0]);
        },
        curScreenExistBtns () {
            return Object.entries(this.curScreenButtonRules)
                .filter((btnArrItem) => btnArrItem[1] === true)
                .map((btnArrItem) => btnArrItem[0]);
        },
        curScreenFilterBtns () {
            return Object.entries(this.curScreenButtonRules)
                .filter((btnArrItem) => btnArrItem[1] === false)
                .map((btnArrItem) => btnArrItem[0]);
        },
        // 基本按钮
        baseAllOperationMap () {
            return {
                canSearch: {
                    name: "高级筛选",
                    type: "canSearch",
                    size: "default",
                    event: "clickSearch"
                },
                canCreate: {
                    name: "添加数据",
                    type: "canCreate",
                    icon: "md-add",
                    size: "default",
                    event: "clickCreate"
                },
                canShow: {
                    name: "查看",
                    type: "canShow",
                    btnType: "text",
                    size: "small",
                    event: "clickShow"
                },
                canUpdate: {
                    name: "编辑",
                    type: "canUpdate",
                    btnType: "text",
                    size: "small",
                    event: "clickUpdate"
                },
                canBatchUpdate: {
                    name: "批量修改",
                    type: "canBatchUpdate",
                    size: "default",
                    disabled: this.selectIds ? !this.selectIds.length : true,
                    event: "clickBatchUpdate"
                },
                canDrag: {
                    name: "拖拽事件",
                    type: "canDrag",
                    event: "dealDrag"
                },
                canDelete: {
                    name: "删除",
                    type: "canDelete",
                    btnType: "text",
                    size: "small",
                    event: "clickDelete"
                },
                canBatchDelete: {
                    name: "批量删除",
                    type: "canBatchDelete",
                    size: "default",
                    disabled: this.selectIds ? !this.selectIds.length : true,
                    event: "clickBatchDelete"
                },
                canImport: {
                    name: "从excel导入",
                    type: "canImport",
                    size: "small",
                    event: "clickImport"
                },
                canBatchImport: {
                    name: "从excel导入",
                    type: "canBatchImport",
                    size: "default",
                    event: "clickBatchImport"
                },
                canExport: {
                    name: "数据导出",
                    type: "canExport",
                    size: "small",
                    event: "clickExport"
                },
                canBatchExport: {
                    name: "数据导出",
                    type: "canBatchExport",
                    size: "default",
                    event: "clickBatchExport"
                },
                canShare: {
                    name: "分享",
                    type: "canShare",
                    size: "large",
                    btnType: "text",
                    event: "clickShare"
                },
                canPrint: {
                    name: "打印",
                    type: "canPrint",
                    size: "large",
                    btnType: "text",
                    event: "openPrintModal"
                },

                ...(this.selfBtnOperationMap || {})
            };
        },
        baseOperationMap () {
            return this.$categoryMapToMap(
                this.baseAllOperationMap,
                null,
                [],
                this.curScreenExistBtns
            );
        }
    },
    created () {
        // 处理之前保存的筛选，分页等信息
        this.modBeforeInit && this.modBeforeInit();

        if (this.showMode !== true && this.stopModInit !== true) {
            this.modInit();
        }
    },
    methods: {
        // 初始化
        modInit () {
            this.modObj = undefined;
            if (this.defaultModObj) {
                this.modObj = this.defaultModObj;
                this.getModAfter && this.getModAfter();
            } else {
                this.modKey && this.getModData();
            }
        },

        // 接口 -获取Mod
        getModData () {
            this.modSchemaLoading = true;
            this.modSchemaErrorMsg = "";
            this.$https({
                url: this.schemaUrlParams,
                params: {
                    _key: this.modKey,
                    screenKey: this.screenKey,
                    isRef: this.isRef
                },
                next: (res) => {
                    this.modSchemaLoading = false;
                },
                error: (res) => {
                    this.modSchemaErrorMsg = res.msg;
                },
                callback: (data) => {
                    this.getModCall && this.getModCall(data);
                    this.modObj = data;
                    this.getModAfter && this.getModAfter();
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/base/modSchemaMixin.js